import React from 'react'

export default function MenuToggler() {
    return (
        <div className="menu-toggler h-12 w-12">
            <svg viewBox="0 0 61 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.60266 47.3056H53.2187V42.0494H7.60266V47.3056ZM7.60266 34.1651H53.2187V28.909H7.60266V34.1651ZM7.60266 15.7685V21.0247H53.2187V15.7685H7.60266Z" fill="white"/>
            </svg>
        </div>
    )
}
